<div>
  <span
    *ngIf="!isExpired"
    class="btn btn-link icon-cross"
    [attr.data-test-id]="buildActionButtonTestId(CellActionTypes.REMOVE)"
    [attr.id]="idNameAttr(['remove', rowIndex.toString(), cellIndex.toString()])"
    [ngbTooltip]="tooltipDescription(CellActionTypes.REMOVE) | translate"
    (click)="remove()"
    ><svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon
  ></span>
</div>
